import { Box, Grid } from '@mui/material';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { theme } from '../../services/theme';

export const AuthLayout: FC = ({ children }) => (
  <>
    <Grid sx={{ flexGrow: 1 }} container spacing={0}>
      <Grid
        item
        xs={6}
        sx={{
          [theme.breakpoints.down('md')]: {
            width: '100%',
            maxWidth: '100%',
            flexBasis: '100%',
          },
        }}
      >
        {children || <Outlet />}
      </Grid>
      <Grid
        item
        xs={6}
        sx={{
          alignContent: 'flex-start',
          alignItems: 'flex-start',
          justify: 'flex-start',
          [theme.breakpoints.down('md')]: {
            display: 'none',
          },
        }}
      >
        <Box
          sx={{
            backgroundImage: 'url(/logos/authBanner.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            height: '100%',
            width: '60%',
            [theme.breakpoints.down('xl')]: {
              width: '80%',
            },
            [theme.breakpoints.down('lg')]: {
              width: '95%',
            },
          }}
        />
      </Grid>
    </Grid>
  </>
);
